<div class="card mb-4">
    <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
            <h2 class="mb-0"><i class="fa fa-headset"></i> RSA Operation Center</h2>
        </div>
    </div>
    <div class="card-body">
        <form [formGroup]="certificateReportForm" (ngSubmit)="onSubmit()">
            <div class="row g-3 align-items-end">
                <div class="col-md-4 mb-3">
                    <div class="form-group">
                        <label for="certificateNumber"><i class="fa fa-certificate"></i> Certificate Number</label>
                        <input type="text" id="certificateNumber" formControlName="certificateNumber" class="form-control" 
                            [ngClass]="{ 'is-invalid': submitted && f.certificateNumber.errors }" placeholder="Enter certificate number" />
                        <div *ngIf="submitted && f.certificateNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.certificateNumber.errors.required">Certificate Number is required</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <div class="form-group">
                        <label for="chasisNumber"><i class="fa fa-car"></i> Chassis Number</label>
                        <input type="text" id="chasisNumber" formControlName="chasisNumber" class="form-control" placeholder="Enter chassis number" />
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <div class="form-group">
                        <label for="contactNumber"><i class="fa fa-phone"></i> Contact Number</label>
                        <input type="text" id="contactNumber" formControlName="contactNumber" class="form-control" placeholder="Enter contact number" />
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-8 offset-md-4">
                    <div class="d-grid gap-3 d-md-flex justify-content-md-end">
                        <button [disabled]="loading" class="btn btn-primary me-md-2">
                            <i class="fa fa-search me-2"></i>
                            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                            Search
                        </button>
                        <button type="button" (click)="onReset()" class="btn btn-secondary">
                            <i class="fa fa-redo me-2"></i>
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
